// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/antd/dist/reset.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.trigger {
  padding: 0 24px;
  font-size: 18px;
  line-height: 56px;
  cursor: pointer;
  transition: color 0.3s;
  color: rgba(255, 255, 255, 0.6);
}

.trigger:hover {
  color: #ffffff;
}

.logo {
  height: 56px;
  margin: 0px;
  background: "#114373";
  display: flex;
  justify-content: center;
  align-items: center;
}

.site-layout .site-layout-background {
  background: #fff;
}

.ant-carousel .slick-prev,
.ant-carousel .slick-prev:hover,
.ant-carousel .slick-prev:focus {
  font-size: 25px;
  left: 0;
  z-index: 3;
  color: black;
}

.ant-carousel .slick-next,
.ant-carousel .slick-next:hover,
.ant-carousel .slick-next:focus {
  font-size: 25px;
  right: 5px;
  z-index: 3;
  color: black;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,eAAe;EACf,OAAO;EACP,UAAU;EACV,YAAY;AACd;;AAEA;;;EAGE,eAAe;EACf,UAAU;EACV,UAAU;EACV,YAAY;AACd","sourcesContent":["@import \"~antd/dist/reset.css\";\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.trigger {\n  padding: 0 24px;\n  font-size: 18px;\n  line-height: 56px;\n  cursor: pointer;\n  transition: color 0.3s;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.trigger:hover {\n  color: #ffffff;\n}\n\n.logo {\n  height: 56px;\n  margin: 0px;\n  background: \"#114373\";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.site-layout .site-layout-background {\n  background: #fff;\n}\n\n.ant-carousel .slick-prev,\n.ant-carousel .slick-prev:hover,\n.ant-carousel .slick-prev:focus {\n  font-size: 25px;\n  left: 0;\n  z-index: 3;\n  color: black;\n}\n\n.ant-carousel .slick-next,\n.ant-carousel .slick-next:hover,\n.ant-carousel .slick-next:focus {\n  font-size: 25px;\n  right: 5px;\n  z-index: 3;\n  color: black;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
